import { useEffect } from "react";
import { useValidationLabelUtils } from "./ValidationInfoProvider";

export const useValidationLabel = (
  path: string,
  label?: string,
): string | null => {
  const { getLabel, removeLabel, setLabel } = useValidationLabelUtils();
  useEffect(() => {
    // set
    if (label) {
      setLabel(path, label);
    }
    // remove
    return () => removeLabel(path);
  }, [path, label, setLabel, removeLabel]);

  // get
  return getLabel(path) ?? label ?? null;
};
